import { Injectable } from "@angular/core";
import { ExportContext, ExportFileFormat, ExportRange, ExportService } from "app/layout/export-overlay";
import { IPagination, IPaginationResult } from "app/common/interfaces";
import { takeUntil } from "rxjs";
import { LATENCY_ERRORS_PROPERTIES, STATUS_OPTIONS } from "./latency-errors.constants";
import { SystemLatencyService } from "app/modules/components/synchronization/system-latency/system-latency.service";
import LogMiddlewareServiceDetailAttributes from "@albatrosdeveloper/ave-models-package/lib/schemas/integrator/log-middleware-service-detail/log-middleware-service-detail.entity";

export interface ExportData {
    documentIdentifier: string;
    message: string;        
    dataReceivedLatency: string;
    dataSentLatency: string;
    status: string;
}

@Injectable()
export class LatencyErrorsReportExport {
    constructor(
        private exportService: ExportService,
        private systemLatencyService: SystemLatencyService
    ) { }


    private transformData(errorsList: LogMiddlewareServiceDetailAttributes[]): ExportData[] {
        return errorsList?.map((item: LogMiddlewareServiceDetailAttributes) => {
            const statusCode = item.status ?? '';
            const statusLabel = STATUS_OPTIONS.find(opt => opt.value === statusCode)?.label ?? statusCode;

            return {
            documentIdentifier: item.documentIdentifier ?? '',
            message: item.message ?? '',
            dataReceivedLatency: JSON.stringify(item.dataReceived ?? {}),
            dataSentLatency: JSON.stringify(item.dataSent ?? {}),
            status: statusLabel,
            };
        });
    }

    export(
        format: ExportFileFormat,
        range: ExportRange,
        totalItems: number,
        pageSize: number,
        pageIndex: number,
        exportId: string,
        exportTitle: string,
        properties: typeof LATENCY_ERRORS_PROPERTIES,
        element,
        optionsFilters: IPagination<LogMiddlewareServiceDetailAttributes>
    ) {
        this.exportService
            .task({
                id: exportId,
                title: exportTitle,
                format,
                iterations: 1,
                start: (ctx: ExportContext) => {
                    ctx.processor.localizeItemProperties(
                        exportTitle,
                        properties ?? LATENCY_ERRORS_PROPERTIES
                    );
                },
                next: (ctx: ExportContext) => {
                    optionsFilters.limitPerPage = range === ExportRange.AllPages ? totalItems : pageSize;
                    optionsFilters.currentPage = range === ExportRange.AllPages ? 1 : pageIndex;

                    this.systemLatencyService
                        .findAllDetailWithCount(
                            optionsFilters,
                            element._id
                        )
                        .pipe(takeUntil(ctx.stopped))
                        .subscribe({
                            next: (res: IPaginationResult<LogMiddlewareServiceDetailAttributes>) => {
                                const errorsList = res?.data[0].data;

                                const rows = this.transformData(errorsList);

                                ctx.processor.addToSection(exportTitle, rows);
                                ctx.next();
                            },
                        });
                },
            })
            .start();
    }

    canStartTask(exportId: string): boolean {
        if (this.exportService.taskIsActive(exportId)) {
            this.exportService.setVisible(true);
            return false;
        }
        return true;
    }
}